document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('search-input');
  const resultsContainer = document.getElementById('autocomplete-results');
  const resultsList = document.getElementById('autocomplete-list');

  async function fetchSuggestions(query) {
    console.log('Fetching suggestions for query:', query);
    const response = await fetch(`/search/suggest.json?q=${query}&resources[type]=product`);
    const data = await response.json();
    console.log('Suggestions fetched:', data.resources.results.products);

    // Filtrar productos que tengan la etiqueta "ocultar-búsqueda"
    const filteredSuggestions = data.resources.results.products.filter(product => {
      return !product.tags.includes('ocultar-búsqueda');
    });

    return filteredSuggestions;
  }

  function renderSuggestions(suggestions) {
    console.log('Rendering suggestions:', suggestions);
    resultsList.innerHTML = ''; // Limpiar el contenido del contenedor de resultados
    if (suggestions.length > 0) {
      suggestions.forEach(suggestion => {
        const li = document.createElement('li');
        li.style.display = 'flex'; // Utilizar flexbox para alinear imagen y texto
        li.style.alignItems = 'center'; // Centrar verticalmente
        li.style.padding = '10px';
        li.style.borderBottom = '1px solid #eee';

        // Crear el contenedor para la imagen
        const img = document.createElement('img');
        img.src = suggestion.image; // URL de la imagen del producto
        img.alt = suggestion.title;
        img.style.width = '50px'; // Ajustar el tamaño de la imagen
        img.style.height = '50px'; // Ajustar el tamaño de la imagen
        img.style.marginRight = '10px'; // Espacio entre la imagen y el texto

        // Crear el enlace para el producto
        const link = document.createElement('a');
        link.href = suggestion.url;
        link.textContent = suggestion.title;
        link.style.textDecoration = 'none';
        link.style.color = 'black';

        // Añadir la imagen y el enlace al elemento li
        li.appendChild(img);
        li.appendChild(link);
        resultsList.appendChild(li);
      });
      resultsContainer.style.display = 'block'; // Mostrar el contenedor
      console.log('Results container displayed.');
    } else {
      resultsContainer.style.display = 'none'; // Ocultar el contenedor si no hay sugerencias
      console.log('No suggestions found. Results container hidden.');
    }
  }

  searchInput.addEventListener('input', async function(event) {
    const query = event.target.value.trim(); // Eliminar espacios en blanco
    console.log('Input event detected. Query:', query);
    if (query.length >= 2) { // Mostrar sugerencias solo si la consulta tiene 2 o más caracteres
      const suggestions = await fetchSuggestions(query);
      renderSuggestions(suggestions);
    } else {
      resultsList.innerHTML = ''; // Limpiar el contenido del contenedor de resultados
      resultsContainer.style.display = 'none'; // Ocultar el contenedor si la consulta es menor a 2 caracteres o está vacía
      console.log('Query too short or empty. Results container hidden.');
    }
  });

  document.addEventListener('click', function(event) {
    if (!resultsContainer.contains(event.target) && event.target !== searchInput) {
      resultsContainer.style.display = 'none'; // Ocultar el contenedor si se hace clic fuera
      console.log('Clicked outside. Results container hidden.');
    }
  });
});
